import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CALENDAR_CHECK: GlameraIconDefinition = {
  name: 'calendar-check',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-calendar-check-hanger glm-calendar-check-hanger-left" pathLength="1" d="M8 2v4"></path>
    <path class="glm-calendar-check-hanger glm-calendar-check-hanger-right" pathLength="1" d="M16 2v4"></path>
    <rect class="glm-calendar-check-body" pathLength="1" width="18" height="18" x="3" y="4" rx="2"></rect>
    <path class="glm-calendar-check-header" d="M3 10h18"></path>
    <path class="glm-calendar-check-mark" d="m9 16 2 2 4-4"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-calendar-check-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './calendar-check.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CalendarCheckIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CALENDAR_CHECK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
